// time picker directive
//
//  <time-picker ng-model="dateTimeObj"
//               start-time="dateTimeObj"
//               end-time="dateTimeObj"
//               display-format="h:mm a"
//               step-minutes="30"
//               show-duration="false"
//               scroll-item-into-focus="false"
//               ></time-picker>
//
//  options:
//    - start-time: defaults to Now
//    - end-time: defaults to Now + 1 day
//    - display-format: defaults to 'h:mm a' (moment.js format parameters)
//    - step-minutes: defaults to 30
//    - show-duration: defaults to false

let module = angular.module('app.directives');

module.directive('timePicker', () => {
  'ngInject';

  return {
    restrict: 'E',
    require: 'ngModel',
    scope: {
      ngModel: '=',
      displayFormat: '@',
      startTime: '=?',
      endTime: '=?',
      stepMinutes: '@',
      showDuration: '@',
    },
    template: `
      <div class="input-group">
        <input type="text"
               class="form-control"
               ng-click="showOptions()"
               ng-model="dateModelFn"
               ng-model-options="{getterSetter: true, updateOn: 'blur'}">
        <div class="input-group-btn">
          <button type="button" class="btn btn-default dropdown-toggle" ng-click="toggleOptions()"><span class="caret"></span></button>
          <ul class="dropdown-menu"
              role="menu"
              style="max-height:200px; overflow-y:scroll;"
              >
            <li ng-repeat="option in options"
                ng-class="{active: option.hourValue == ngModelHourValue}"
                data-hour-value="{{option.hourValue}}"
                >
              <a href="javascript://" ng-click="selectOption(option.value)">
                {{option.label}}
              </a>
            </li>
          </ul>
        </div>
      </div>
    `,
    link: (scope, element, attrs, ngModelCtrl) => {
      let displayFormat = scope.displayFormat || 'h:mm a';
      let startTime = scope.startTime || moment().startOf('day').toDate();
      let endTime = scope.endTime || moment(startTime).add(1, 'day').toDate();
      let stepMinutes = scope.stepMinutes || 30;
      if (stepMinutes < 0) {
        throw Error('Invalid value for step-minutes: ' + stepMinutes);
      }

      scope.dateModelFn = function (value) {
        if (arguments.length) {
          value = tryParseTime(value);
          ngModelCtrl.$setViewValue(value ? value.toDate() : null);
          ngModelCtrl.$commitViewValue();
        } else {
          value = ngModelCtrl.$modelValue;
        }

        if (value) {
          scope.ngModelHourValue = moment(value).format('HHmm');
          return moment(value).format(displayFormat);
        } else {
          return '';
        }
      };

      scope.$watch(
        'startTime',
        _.throttle((newStartTime) => {
          startTime = newStartTime || moment().startOf('day').toDate();
          endTime = scope.endTime || moment(startTime).add(1, 'day').toDate();
          if (ngModelCtrl.$modelValue < startTime) {
            // Make sure current time is after start time
            console.log('Adjusting current time to', startTime);
            ngModelCtrl.$setViewValue(startTime);
            ngModelCtrl.$commitViewValue();
          }
          scope.options = buildOptions(
            startTime,
            endTime,
            stepMinutes,
            scope.showDuration,
            displayFormat
          );
        }, 100)
      );

      let menu = element.find('.dropdown-menu');
      let isMenuVisible = false;

      scope.showOptions = () => {
        if (!isMenuVisible) {
          menu.show();
          isMenuVisible = true;
          scrollItemIntoFocus();
          // hack the position relative to the input, not the button
          let inputWidth = element.find('input').css('width');
          menu.css({ left: `-${inputWidth}` });
        }
      };

      function scrollItemIntoFocus() {
        // scroll the closest option into focus
        let currentValue = moment(ngModelCtrl.$modelValue).format('HHmm');
        let closest = null;
        menu.find('li').each((i, item) => {
          let itemValue = $(item).data('hour-value');
          let diff = Math.abs(itemValue - currentValue);
          if (!closest || diff < closest.diff) {
            closest = { diff: diff, item: item };
          }
        });
        if (closest) {
          menu.get(0).scrollTop = closest.item.offsetTop;
        }
      }

      scope.hideOptions = () => {
        setTimeout(() => menu.hide(), 50);
        isMenuVisible = false;
      };

      scope.toggleOptions = () => {
        if (isMenuVisible) {
          scope.hideOptions();
        } else {
          scope.showOptions();
        }
      };

      scope.selectOption = (option) => {
        //console.log('selecting option', option);
        ngModelCtrl.$setViewValue(option);
        ngModelCtrl.$commitViewValue();
        scope.hideOptions();
      };

      // Let stray clicks off the menu close the menu
      let strayClickHandler = (e) => {
        if (!isMenuVisible) {
          return true;
        }
        if ($.contains(element.find('.input-group')[0], e.target)) {
          //console.log('click was inside directive; leaving menu open');
          e.preventDefault();
          e.stopPropagation();
        } else {
          //console.log('hiding from body click');
          scope.hideOptions();
        }
      };
      $('body').on('click', strayClickHandler);
      scope.$on('$destroy', () => {
        $('body').off('click', strayClickHandler);
      });
    },
  };
});

function buildOptions(startTime, endTime, stepMinutes, showDuration, displayFormat) {
  // Dynamically determine which options to show
  // Account for 24-hour wrap-around if necessary
  let options = [];

  if (endTime < startTime || !endTime || !startTime) {
    console.warn('Unable to generate options between', startTime, 'and', endTime);
    return options;
  }

  let startDate = moment(startTime).date();
  let ticker = moment(startTime).startOf('hour');
  let i = 0;
  while (ticker.isBefore(endTime)) {
    if (++i > 1000) {
      console.error('Infinite loop?', startTime, ticker, endTime, stepMinutes);
      return;
    }
    let option = {
      value: ticker.toDate(),
      label: ticker.format(displayFormat),
      hourValue: ticker.format('HHmm'),
    };
    if (showDuration) {
      let diff = ticker.diff(startTime, 'minutes');
      if (diff < 0) {
        ticker = ticker.clone().add(stepMinutes, 'minutes');
        continue; //skip negatives
      }
      let label = labelForDuration(diff, ticker.date() != startDate);
      option.label += ' (' + label + ')';
    }
    options.push(option);
    ticker = ticker.clone().add(stepMinutes, 'minutes');
  }

  return options;
}

function labelForDuration(diff, isDifferentDay) {
  let displayDiff;
  if (diff < 60) {
    displayDiff = `${diff} minutes`;
  } else {
    let fracHours = Math.round((10.0 * diff) / 60.0) / 10.0;
    displayDiff = `${fracHours} hours`;
  }
  if (isDifferentDay) {
    displayDiff += ' - Following Day';
  }
  return displayDiff;
}

function tryParseTime(string) {
  const formats = ['h:mm a', 'h:mm A', 'h:mma', 'h:mmA', 'h:m a', 'h:m A', 'h:ma', 'h:mA', 'HH:mm'];
  let result = null;
  if (!string) return result;
  _.each(formats, (f) => {
    result = moment(string, f);
    if (result.isValid()) {
      return false; //stop iteration
    } else {
      console.log('Unable to parse time', string, 'as', f);
    }
  });
  return result;
}

export default module;



// WEBPACK FOOTER //
// ./app/directives/time-picker.js